import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Search, Menu, X } from 'lucide-react';
import CartDrawer from './CartDrawer';

const Header = ({ 
  cart, 
  cartItemCount, 
  cartTotal, 
  updateCartItemQuantity, 
  removeFromCart 
}) => {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const menuItems = [
    { path: '/', label: 'Home' },
    { path: '/collection', label: 'Collection' },
    { path: '/steals-deals', label: 'Steals & Deals' },
    { path: '/contact', label: 'Contact' },
    { path: '/about', label: 'About' }
  ];

  return (
    <>
      <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-40 slide-down in-view">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <div className="flex-shrink-0">
              <Link to="/" className="flex items-center">
                <img 
                  src="https://res.cloudinary.com/dm8rx6sks/image/upload/v1762201291/sneaker-store/branding/bx-kicks-logo.png" 
                  alt="BX Kicks Logo" 
                  className="h-12 w-auto rounded-lg"
                />
              </Link>
            </div>

            {/* Navigation - Desktop */}
            <nav className="hidden md:flex space-x-8">
              {menuItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className="nav-link"
                  data-testid={`${item.label.toLowerCase()}-nav-link`}
                >
                  {item.label}
                </Link>
              ))}
            </nav>

            {/* Right side - Search & Cart */}
            <div className="flex items-center space-x-4">
              {/* Search Button */}
              <button 
                className="p-2 text-gray-600 hover:text-gray-900 transition-colors"
                data-testid="search-button"
              >
                <Search size={20} />
              </button>

              {/* Cart Button */}
              <button
                onClick={() => setIsCartOpen(true)}
                className="relative p-2 text-gray-600 hover:text-gray-900 transition-colors"
                data-testid="cart-button"
              >
                <ShoppingCart size={20} />
                {cartItemCount > 0 && (
                  <span 
                    className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-medium"
                    data-testid="cart-item-count"
                  >
                    {cartItemCount}
                  </span>
                )}
              </button>

              {/* Mobile Menu Button */}
              <button
                className="md:hidden p-2 text-gray-600 hover:text-gray-900 transition-colors"
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                data-testid="mobile-menu-button"
              >
                {isMobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isMobileMenuOpen && (
            <div className="md:hidden py-4 border-t border-gray-200" data-testid="mobile-navigation">
              <div className="flex flex-col space-y-2">
                {menuItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className="nav-link block"
                    onClick={() => setIsMobileMenuOpen(false)}
                    data-testid={`mobile-${item.label.toLowerCase()}-nav-link`}
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      </header>

      {/* Cart Drawer */}
      <CartDrawer
        isOpen={isCartOpen}
        onClose={() => setIsCartOpen(false)}
        cart={cart}
        cartTotal={cartTotal}
        updateCartItemQuantity={updateCartItemQuantity}
        removeFromCart={removeFromCart}
      />
    </>
  );
};

export default Header;